import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface NavigationItemProps {
    icon: React.ReactNode;
    text: string;
    selected?: boolean;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    to?: string;
}

const NavigationItem: React.FC<NavigationItemProps> = ({
    icon,
    text,
    selected = false,
    onClick,
    to,
}) => {
    return (
        <ListItemButton
            selected={selected}
            onClick={onClick}
            component={to ? RouterLink : 'div'}
            to={to}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{text}</ListItemText>
        </ListItemButton>
    );
};

export default NavigationItem;